class DialogModal extends HTMLElement {
  constructor (self) {
    self = super(self)

    self.openTimeout = 300
    self.closeTimeout = 100
    self.contentLoading = false
    self.nextPage = 1

    return self
  }

  attributeChangedCallback(attr) {
    this._observe(attr)
  }

  connectedCallback () {
    this._setActions()
    this._setActionTriggers()
  }

  static get observedAttributes() {
    return ['open', 'confirm', 'dismiss', 'closingx', 'closing', 'die']
  }

  get dialogBody () {
    return this.querySelector('dialog-body')
  }

  _observe (prop) {
    var actionDo = (action) => {
      var actions = this.querySelector('dialog-actions'),
          calling = actions.querySelector(`[action="${action}"]`)
      if (this.hasAttribute(action)) {
        calling = calling || document.createElement('dialog-action')
        calling.setAttribute('action', action)
        calling.textContent = (this.getAttribute(action))
        calling.parentNode || actions.appendChild(calling)
      } else {
        calling && calling.parentNode.removeChild(calling)
      }
    }
    var properties = {
      dismiss: () => actionDo('dismiss'),
      confirm: () => actionDo('confirm'),
      open: () => {
        if (this.hasAttribute('open')) {
          if (this.hasAttribute('src') && !this.dialogBody.childNodes.length) {
            this.fetchContent()
          }

          this.style.animation = `fade-zoom-in ${this.openTimeout}ms ease-in`
        }
        this._lockBodyIfOpen(this.hasAttribute('open'))
      },
      closing: () => {
        if (this.hasAttribute('closing')) {
          this.style.animation = `fade-zoom-out ${this.closeTimeout}ms ease-out`
          setTimeout(() => {
            this.removeAttribute('open')
            this.removeAttribute('closing')
            this._lockBodyIfOpen(false)
          }, this.closeTimeout)
        }
      },
      die: () => {
        if (this.hasAttribute('die')) {
          this.style.animation = `fade-zoom-out ${this.closeTimeout}ms ease-out`
          setTimeout(() => {
            this.parentNode.removeChild(this)
            this._lockBodyIfOpen(false)
          }, this.closeTimeout)
        }
      },
      closingx: () => {
        var calling, closingx = this.querySelector('dialog-close')
        if (this.hasAttribute('closingx')) {
          calling = closingx || document.createElement('dialog-close')
          calling.setAttribute('action', 'dismiss')
          calling.parentNode || this.querySelector('dialog-header')
            .insertBefore(calling, this.querySelector('dialog-title'))
        } else {
          calling = closingx
          calling && calling.parentNode.removeChild(calling)
        }
      }
    }
    return properties.hasOwnProperty(prop) ? properties[prop]() : undefined
  }

  _lockBodyIfOpen(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  _setActions (code) {
    if (this.hasAttribute('onconfirm')) {
      code = this.getAttribute('onconfirm')
      if (code) {
        this._onConfirm = () => eval(code)
      }
      this.removeAttribute('onconfirm')
    }

    if (this.hasAttribute('ondismiss')) {
      code = this.getAttribute('ondismiss')
      if (code && code !== 'false') {
        this._onDismiss = () => eval(code)
      }
      else {
        this._onDismiss = () => eval(false)
      }
      this.removeAttribute('ondismiss')
    }

    this.setAttribute('action', 'dismiss')
  }

  _trigger (ev) {
    ev.stopPropagation()
    if (ev.target.hasAttribute('action')) {
      this._actions(ev.target.getAttribute('action'))
    }
  }

  _setActionTriggers () {
    this.removeEventListener('click', this._trigger)
    this.addEventListener('click', this._trigger)

    if (this.hasAttribute('src') && this.hasAttribute('infinite-scroll')) {
      this.dialogBody.removeEventListener('scroll', this.infiniteScroll.bind(this))
      this.dialogBody.addEventListener('scroll', this.infiniteScroll.bind(this))
    }
  }

  _onDismiss () {
    this._destroy()
  }

  _onConfirm () {
    this._onDismiss()
  }

  _destroy () {
    this.removeAttribute('open')
    if (!this.hasAttribute('persist')) {
      this.parentNode.removeChild(this)
    }
  }

  _actions (selected) {
    var options = {
      dismiss: () => {
        this._onDismiss()
      },
      confirm: () => {
        this._onConfirm()
      }
    }

    return selected ? options[selected]() : Object.keys(options)
  }

  infiniteScroll (ev) {
    if (ev.target.scrollTop + ev.target.clientHeight >= ev.target.scrollHeight) {
      this.fetchContent()
    }
  }

  fetchContent () {
    if (this.contentLoading) { return }

    this.dialogBody.innerHTML += this.spinnerHTML()
    this.contentLoading = true

    fetch(this.buildFetchURL())
      .then(response => response.text())
      .then((html) => {
        this.dialogBody.removeChild(this.dialogBody.lastChild)
        this.dialogBody.innerHTML += html
        this.nextPage += 1
        this.contentLoading = false
      })
  }

  buildFetchURL () {
    const url = new URL(this.getAttribute('src'))
    const conector = url.search ? '&' : '?'

    url.search += conector + `page=${this.nextPage}`

    return url
  }

  spinnerHTML () {
    return '<div class="core-align-center rnk-margin-bottom-large"><i class="core-Icon-spinner-inline"></div>'
  }
}

export default DialogModal
